import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import RepeatableField from './RepeatableField';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';

export default (element, store) => {
  const root = createRoot(element);
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <RepeatableField
          fieldToRepeat={element.dataset.field ? JSON.parse(element.dataset.field) : null}
          examType={element.dataset.examType}
        />
      </Provider>
    </ErrorBoundary>,
  );
};
